import React, { useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  TextField,
  IconButton,
  FormControl,
  FormHelperText,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch } from "react-redux";
import { partner_registerApi } from "../../app/slices/partner_registerSlice";
import { Refresh } from "@mui/icons-material";

const PartnerSearch = () => {
  const dispatch = useDispatch();

  // ===========================
  // LABEL + VALUE OPTIONS
  // ===========================
  const filterOptions = [
    { label: "Partner Name", value: "name" },
    { label: "Entity Name", value: "Entityname" },
    { label: "Partner Code", value: "partnerCode" },
    { label: "Mobile", value: "mobileNo" },
    { label: "Date", value: "Date" },
  ];

  const [selectedFilter, setSelectedFilter] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // error state
  const [errors, setErrors] = useState({
    filter: "",
    input: "",
    startDate: "",
    endDate: "",
  });

  // ===========================
  // 🔍 SEARCH HANDLER
  // ===========================
  const handleSearch = () => {
    let newErrors = { filter: "", input: "", startDate: "", endDate: "" };
    let hasError = false;

    // Validate filter
    if (!selectedFilter) {
      newErrors.filter = "Please select a filter option";
      hasError = true;
    }

    // Validate input (when not "Date")
    if (selectedFilter && selectedFilter !== "Date" && !inputValue.trim()) {
      newErrors.input = `Please enter ${selectedLabel}`;
      hasError = true;
    }

    // Validate dates
    if (selectedFilter === "Date") {
      if (!startDate) {
        newErrors.startDate = "Start Date is required";
        hasError = true;
      }
      if (!endDate) {
        newErrors.endDate = "End Date is required";
        hasError = true;
      }
      if (startDate && endDate && startDate > endDate) {
        newErrors.endDate = "End Date cannot be earlier than Start Date";
        hasError = true;
      }
    }

    setErrors(newErrors);

    if (hasError) return; // prevent API call

    // Perform API call
    if (selectedFilter === "Date") {
      dispatch(
        partner_registerApi({
          startDate,
          endDate,
        })
      );
    } else {
      dispatch(
        partner_registerApi({
          [selectedFilter]: inputValue,
        })
      );
    }
  };

  // ===========================
  // ♻ RESET HANDLER
  // ===========================
  const handleReset = () => {
    setInputValue("");
    setStartDate("");
    setEndDate("");
    setSelectedFilter("");
    setErrors({
      filter: "",
      input: "",
      startDate: "",
      endDate: "",
    });

    dispatch(partner_registerApi({})); // get all data
  };

  // Get selected option label
  const selectedLabel =
    filterOptions.find((x) => x.value === selectedFilter)?.label || "";

  return (
    <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
      
      {/* SELECT DROPDOWN */}
      <FormControl sx={{ minWidth: 250 }} error={Boolean(errors.filter)}>
        <Select
          size="small"
          value={selectedFilter}
          onChange={(e) => setSelectedFilter(e.target.value)}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return (
                <span style={{ color: "#777", opacity: 0.8 }}>Search By</span>
              );
            }
            return filterOptions.find((x) => x.value === selected)?.label;
          }}
        >
          {filterOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>

        {errors.filter && (
          <FormHelperText>{errors.filter}</FormHelperText>
        )}
      </FormControl>

      {/* INPUT FIELD */}
      {selectedFilter && selectedFilter !== "Date" && (
        <FormControl sx={{ minWidth: 250 }} error={Boolean(errors.input)}>
          <TextField
            size="small"
            label={`Enter ${selectedLabel}`}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          {errors.input && <FormHelperText>{errors.input}</FormHelperText>}
        </FormControl>
      )}

      {/* DATE RANGE FIELDS */}
      {selectedFilter === "Date" && (
        <>
          <FormControl error={Boolean(errors.startDate)}>
            <TextField
              size="small"
              type="date"
              label="Start Date"
              InputLabelProps={{ shrink: true }}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            {errors.startDate && (
              <FormHelperText>{errors.startDate}</FormHelperText>
            )}
          </FormControl>

          <FormControl error={Boolean(errors.endDate)}>
            <TextField
              size="small"
              type="date"
              label="End Date"
              InputLabelProps={{ shrink: true }}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            {errors.endDate && (
              <FormHelperText>{errors.endDate}</FormHelperText>
            )}
          </FormControl>
        </>
      )}

      {/* BUTTONS */}
      <Box>
        <IconButton color="primary" onClick={handleSearch}>
          <SearchIcon />
        </IconButton>

        <IconButton color="error" onClick={handleReset}>
          <Refresh />
        </IconButton>
      </Box>
    </Box>
  );
};

export default PartnerSearch;







// import React, { useState } from "react";
// import {
//   Box,
//   Select,
//   MenuItem,
//   TextField,
//   IconButton,
//   InputLabel,
//   FormControl,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { useDispatch } from "react-redux";
// import { partner_registerApi } from "../../app/slices/partner_registerSlice";
// import { Refresh } from "@mui/icons-material";

// const PartnerSearch = () => {
//   const dispatch = useDispatch();

//   // ===========================
//   // LABEL + VALUE OPTIONS
//   // ===========================
//   const filterOptions = [
//     { label: "Partner Name", value: "name" },
//     { label: "Entity Name", value: "Entityname" },
//     { label: "Partner Code", value: "partnerCode" },
//     { label: "Mobile", value: "mobileNo" },
//     { label: "Date", value: "Date" },
//   ];

//   const [selectedFilter, setSelectedFilter] = useState("");
//   const [inputValue, setInputValue] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   // ===========================
//   // 🔍 SEARCH HANDLER
//   // ===========================
//   const handleSearch = () => {
//     if (!selectedFilter) return;

//     if (selectedFilter === "Date") {
//       dispatch(
//         partner_registerApi({
//           startDate,
//           endDate,
//         })
//       );
//     } else {
//       dispatch(
//         partner_registerApi({
//           [selectedFilter]: inputValue,
//         })
//       );
//     }
//   };

//   // ===========================
//   // ♻ RESET HANDLER
//   // ===========================
//   const handleReset = () => {
//     setInputValue("");
//     setStartDate("");
//     setEndDate("");
//     setSelectedFilter("");

//     dispatch(partner_registerApi({})); // get all data
//   };

//   // Get selected option label
//   const selectedLabel =
//     filterOptions.find((x) => x.value === selectedFilter)?.label || "";

//   return (
//     <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
//       <FormControl sx={{ minWidth: 250 }}>
//   {/* <InputLabel hrink={false}>Search By</InputLabel> */}

//   <Select
//     size="small"
//     value={selectedFilter}
//     onChange={(e) => setSelectedFilter(e.target.value)}
//     displayEmpty
//     renderValue={(selected) => {
//       if (!selected) {
//         return (
//           <span style={{ color: "#777", opacity: 0.8 }}>
//             Search By
//           </span>
//         );
//       }
//       return filterOptions.find((x) => x.value === selected)?.label;
//     }}
//     sx={{
//       "& .MuiSelect-select": {
//         // py: 1.3,
//       },
//     }}
//   >
//     {filterOptions.map((opt) => (
//       <MenuItem key={opt.value} value={opt.value}>
//         {opt.label}
//       </MenuItem>
//     ))}
//   </Select>
// </FormControl>

//       {/* Dropdown */}
//       {/* <FormControl sx={{ minWidth: 250 }}>
//         <InputLabel>Search By</InputLabel>
//         <Select
//           size="small"
//           value={selectedFilter}
//           onChange={(e) => setSelectedFilter(e.target.value)}
//           label="Search By"
//                   InputLabelProps={{ shrink: true }}
//                   required

//         >
//           {filterOptions.map((opt) => (
//             <MenuItem key={opt.value} value={opt.value}>
//               {opt.label}
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl> */}

//       {/* Show normal input when NOT "Date" */}
//       {selectedFilter && selectedFilter !== "Date" && (
//         <TextField
//           size="small"
//           label={`Enter ${selectedLabel}`}
//           value={inputValue}
//           onChange={(e) => setInputValue(e.target.value)}
//           sx={{ minWidth: 250 }}
//         />
//       )}

//       {/* Show date inputs when filter is "Date" */}
//       {selectedFilter === "Date" && (
//         <>
//           <TextField
//             size="small"
//             type="date"
//             label="Start Date"
//             InputLabelProps={{ shrink: true }}
//             value={startDate}
//             onChange={(e) => setStartDate(e.target.value)}
//           />

//           <TextField
//             size="small"
//             type="date"
//             label="End Date"
//             InputLabelProps={{ shrink: true }}
//             value={endDate}
//             onChange={(e) => setEndDate(e.target.value)}
//           />
//         </>
//       )}

//       <Box>
//         {/* Search Button */}
//         <IconButton color="primary" onClick={handleSearch}>
//           <SearchIcon />
//         </IconButton>

//         {/* Reset Button */}
//         <IconButton color="error" onClick={handleReset}>
//           <Refresh />
//         </IconButton>
//       </Box>
//     </Box>
//   );
// };

// export default PartnerSearch;



// // import React, { useState } from "react";
// // import {
// //   Box,
// //   Select,
// //   MenuItem,
// //   TextField,
// //   IconButton,
// //   InputLabel,
// //   FormControl,
// // } from "@mui/material";
// // import SearchIcon from "@mui/icons-material/Search";
// // import { useDispatch } from "react-redux";
// // import { partner_registerApi } from "../../app/slices/partner_registerSlice";
// // import { Refresh } from "@mui/icons-material";
// // // import { partner_registerApi } from "../redux/slices/partner_registerSlice";

// // const PartnerSearch = () => {
// //   const dispatch = useDispatch();

// //   const filterOptions = [
// //     "name",
// //     "Entityname",
// //     "partnerCode",
// //     "mobileNo",
// //     "Date",
// //   ];

// //   const [selectedFilter, setSelectedFilter] = useState("");
// //   const [inputValue, setInputValue] = useState("");
// //   const [startDate, setStartDate] = useState("");
// //   const [endDate, setEndDate] = useState("");

// //   // ===========================
// //   // 🔍 SEARCH HANDLER
// //   // ===========================
// //   const handleSearch = () => {
// //     if (!selectedFilter) return;

// //     // If user selected Date filter
// //     if (selectedFilter === "Date") {
// //       dispatch(
// //         partner_registerApi({
// //           startDate,
// //           endDate,
// //         })
// //       );
// //     } else {
// //       // For PartnerName, EntityName, PartnerCode, Mobile
// //       dispatch(
// //         partner_registerApi({
// //           [selectedFilter]: inputValue,
// //         })
// //       );
// //     }
// //   };

// //   // ===========================
// //   // ♻ RESET HANDLER
// //   // ===========================
// //   const handleReset = () => {
// //     setInputValue("");
// //     setStartDate("");
// //     setEndDate("");
// //     setSelectedFilter("");

// //     dispatch(partner_registerApi({})); // get all data
// //   };

// //   return (
// //     <Box
// //       sx={{
// //         display: "flex",
// //         // alignItems: "center",
// //         // gap: 1,
// //         // flexWrap: "wrap",
// //         // p: 0,
// //         mb: 2,
// //       }}
// //     >
// //       {/* Dropdown */}

// //       <FormControl sx={{ minWidth: 250 }}>
// //         <InputLabel>Search By</InputLabel>
// //         <Select
// //           size="small"
// //           value={selectedFilter}
// //           // label="Search By"
// //           onChange={(e) => setSelectedFilter(e.target.value)}
// //           required
// //           InputLabelProps={{ shrink: true }}
// //         >
// //           {filterOptions.map((opt) => (
// //             <MenuItem key={opt} value={opt}>
// //               {opt}
// //             </MenuItem>
// //           ))}
// //         </Select>
// //       </FormControl>

// //       {/* Show normal input when NOT "Date" */}
// //       {selectedFilter && selectedFilter !== "Date" && (
// //         <TextField
// //           type={selectedFilter === "Mobile" ? "tel" : "text"}
// //           size="small"
// //           label={`Enter ${selectedFilter}`}
// //           value={inputValue}
// //           onChange={(e) => setInputValue(e.target.value)}
// //           sx={{ minWidth: 250 }}
// //         />
// //       )}

// //       {/* Show date inputs when filter === "Date" */}
// //       {selectedFilter === "Date" && (
// //         <>
// //           <TextField
// //             size="small"
// //             type="date"
// //             label="Start Date"
// //             InputLabelProps={{ shrink: true }}
// //             value={startDate}
// //             onChange={(e) => setStartDate(e.target.value)}
// //           />

// //           <TextField
// //             size="small"
// //             type="date"
// //             label="End Date"
// //             InputLabelProps={{ shrink: true }}
// //             value={endDate}
// //             onChange={(e) => setEndDate(e.target.value)}
// //           />
// //         </>
// //       )}

// //       <Box>
// //         {/* Search Button */}

// //         <IconButton
// //           color="primary"
// //           onClick={handleSearch}
// //           // sx={{ border: "1px solid #1976d2" }}
// //         >
// //           <SearchIcon />
// //         </IconButton>

// //         {/* Reset Button */}
// //         <IconButton
// //           color="error"
// //           onClick={handleReset}
// //           // sx={{ border: "1px solid #d32f2f" }}
// //         >
// //           <Refresh />
// //         </IconButton>
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default PartnerSearch;
